export const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;
